import React from 'react'
import PropTypes from 'prop-types'

import PageTemplateData from '@v4/utils/data/PageTemplateData'
import BaseContainer from '../BaseContainer'
import { useOuterContainer } from './OuterContainer.hooks'

const OuterContainer = props => {
	const [{ rootProps, rootRef }, { handleUpdateHeight }] = useOuterContainer(props)

	return (
		<BaseContainer
			{...rootProps}
			ref={rootRef}
			onLoad={handleUpdateHeight}
			onTransitionEnd={handleUpdateHeight}
			onAnimationEnd={handleUpdateHeight}
		/>
	)
}

OuterContainer.propTypes = {
	collection: PropTypes.oneOf([PageTemplateData.SORT_GROUPS.HEADER, PageTemplateData.SORT_GROUPS.FOOTER]),
}

export default OuterContainer
